"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.autoComplete = exports.convertAddress = exports.flattenAddress = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _underscore = _interopRequireDefault(require("underscore"));

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ADDRESS_FIELDS = ['mailingName', 'address1', 'secondary', 'address2', 'city', 'state', 'postCode', 'zip', 'country'];

var flattenAddress = function flattenAddress(addressObj) {
  return _underscore.default.filter(ADDRESS_FIELDS.map(function (key) {
    return addressObj[key];
  }), function (o) {
    return !_underscore.default.isUndefined(o) && o !== '';
  }).join(', ');
};

exports.flattenAddress = flattenAddress;

var convertAddress = function convertAddress(addressObj) {
  return _underscore.default.pick(_objectSpread({
    postCode: addressObj.zip,
    secondary: addressObj.address2
  }, _underscore.default.omit(addressObj, 'zip', 'address2')), function (val) {
    return !_underscore.default.isUndefined(val) && val !== '';
  });
};

exports.convertAddress = convertAddress;

function getAccessToken(accessToken) {
  var token = _underscore.default.isFunction(accessToken) ? accessToken() : accessToken;

  if (token && token.then) {
    return token;
  }

  return new Promise(function (r) {
    return r(token);
  });
}

var autoComplete = function autoComplete(accessToken, baseUrl) {
  return function (address) {
    var suggestions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    var url = "".concat(baseUrl, "/address/autocomplete");
    var params = {
      prefix: address.address1,
      cityFilter: address.city,
      stateFilter: address.state,
      suggestions: suggestions
    };
    return new Promise(function (resolve, reject) {
      getAccessToken(accessToken).then(function (token) {
        var headers = {
          'Content-Type': 'application/json'
        };

        if (token && token.length > 0) {
          headers.Authorization = "Bearer ".concat(token);
        }

        _axios.default.get(url, {
          headers: headers,
          params: params
        }).then(function (_ref) {
          var data = _ref.data;
          return resolve(data);
        }).catch(reject);
      }).catch(reject);
    });
  };
};

exports.autoComplete = autoComplete;

var validate = function validate(accessToken, baseUrl) {
  return function (address) {
    var candidates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var url = "".concat(baseUrl, "/address/validate");
    return new Promise(function (resolve, reject) {
      getAccessToken(accessToken).then(function (token) {
        var headers = {
          'Content-Type': 'application/json'
        };

        if (token && token.length > 0) {
          headers.Authorization = "Bearer ".concat(token);
        }

        _axios.default.post(url, address, {
          headers: headers,
          params: {
            candidates: candidates
          }
        }).then(function (_ref2) {
          var data = _ref2.data;

          if (_underscore.default.isArray(data)) {
            if (data.length === 1 && data[0].valid) {
              resolve({
                valid: true,
                candidates: data
              });
            } else {
              resolve({
                valid: false,
                candidates: data
              });
            }
          } else {
            resolve({
              valid: false
            });
          }
        }).catch(reject);
      }).catch(reject);
    });
  };
};

exports.validate = validate;